export const isProduction =
  process.env.NODE_ENV === 'production' && process.env.CHAMA_APP_ENVIRONMENT === 'production';

export const isBuild = process.env.NODE_ENV === 'production';

export default {
  isProduction,
  isBuild,
};



// WEBPACK FOOTER //
// ../utils/constants/environment.js